import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BandsSelection.css';

const BandsSelection = () => {
    const navigate = useNavigate();
    const [userInput, setUserInput] = useState('');

    // Bands workout presets (from Android code)
    const bandsWorkouts = [
        { code: "lclc", name: "leg chest leg chest Workout" },
        { code: "cbl", name: "chest back leg Workout" },
        { code: "bcc", name: "back chest chest Workout" },
        { code: "ocob", name: "core chest core back Workout" },
        { code: "roll", name: "arm core legs legs Workout" },
        { code: "solb", name: "shoulder core legs back Workout" },
        { code: "lclc", name: "legs chest legs chest Workout" },
        { code: "clbl", name: "chest legs back legs Workout" },
        { code: "lbcc", name: "legs back chest chest Workout" },
        { code: "olclob", name: "core legs chest legs core back Workout" },
        { code: "lroll", name: "legs arm core legs legs Workout" },
        { code: "lsoll", name: "legs shoulder core legs legs Workout" },
        { code: "lbcblc", name: "legs back chest back legs chest Workout" },
        { code: "cbbl", name: "chest back back legs Workout" },
        { code: "bcbcb", name: "back chest back chest back Workout" },
        { code: "ocobo", name: "core chest core back core Workout" },
        { code: "brolol", name: "back arm core legs core legs Workout" },
        { code: "bsoll", name: "back shoulder core legs legs Workout" },
        { code: "lrlc", name: "legs arm legs chest Workout" },
        { code: "rlbl", name: "arm legs back legs Workout" },
        { code: "lbccr", name: "legs back chest chest arm Workout" },
        { code: "olclobr", name: "core legs chest legs core back arm Workout" },
        { code: "rololr", name: "arm core legs core legs arm Workout" },
        { code: "solor", name: "shoulder core legs core arm Workout" }
    ];

    // Muscle groups mapping (from Android app)
    const muscleGroups = [
        { name: "legband", code: "l" },
        { name: "chestband", code: "c" },
        { name: "backband", code: "b" },
        { name: "coreband", code: "o" },
        { name: "armband", code: "r" },
        { name: "shoulderband", code: "s" }
    ];

    const allowedChars = "lcbors";

    // Handle adding character to input
    const addCharacter = (char) => {
        const newInput = userInput + char;
        const lastThreeChars = newInput.slice(-3);

        // Prevent three consecutive same characters
        if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
            setUserInput(newInput);
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        const input = e.target.value.toLowerCase();
        const validInput = input.split('').filter(char => allowedChars.includes(char)).join('');

        // Check for three consecutive same characters
        let result = '';
        for (let i = 0; i < validInput.length; i++) {
            const char = validInput[i];
            const lastThreeChars = result.slice(-2) + char;
            if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
                result += char;
            }
        }

        setUserInput(result);
    };

    // Handle preset workout selection
    const handlePresetSelect = (workoutCode) => {
        setUserInput(workoutCode);
    };

    // Handle next button with URL encoding fix
    const handleNext = () => {
        if (userInput.trim() !== '') {
            // Navigate with properly encoded workout code
            const encodedWorkoutCode = encodeURIComponent(userInput);
            navigate(`/bands-rep-count/${encodedWorkoutCode}`, {
                state: {
                    workoutCode: userInput, // Pass unencoded version in state
                    workoutType: 'bands'
                }
            });
        }
    };

    // Generate random background image
    const getRandomBackground = () => {
        const randomIndex = Math.floor(Math.random() * 88) + 1;
        return `url(/assets/images/v${randomIndex}.jpg)`;
    };

    return (
        <div
            className="bands-selection-container"
            style={{
                backgroundImage: getRandomBackground(),
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            {/* Dark overlay */}
            <div className="bands-overlay"></div>

            {/* Fixed top bar */}
            <div className="bands-top-bar">
                <button
                    className="bands-back-button"
                    onClick={() => navigate('/')}
                >
                    ← Back
                </button>

                <input
                    type="text"
                    className="bands-input"
                    value={userInput}
                    onChange={handleInputChange}
                    placeholder="Enter bands code..."
                />

                <button
                    className="bands-next-button"
                    onClick={handleNext}
                    disabled={userInput.trim() === ''}
                >
                    Next 🔥
                </button>
            </div>

            {/* Scrollable content */}
            <div className="bands-content">
                <div className="bands-header">
                    <h1>🔥 RESISTANCE BANDS 🔥</h1>
                    <p>Versatile resistance training with bands!</p>
                </div>

                {/* Muscle group buttons */}
                <div className="muscle-groups-grid">
                    {muscleGroups.map((group) => (
                        <button
                            key={group.code}
                            className="muscle-group-button"
                            onClick={() => addCharacter(group.code)}
                        >
                            <span className="muscle-code">{group.code}</span>
                            <span className="muscle-name">{group.name}</span>
                        </button>
                    ))}
                </div>

                {/* Character selector */}
                <div className="character-selector">
                    <h3>Quick Character Input:</h3>
                    <div className="character-grid">
                        {allowedChars.split('').map((char) => (
                            <button
                                key={char}
                                className="character-button"
                                onClick={() => addCharacter(char)}
                            >
                                {char}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Preset bands workouts */}
                <div className="preset-workouts">
                    <h3>🎯 Resistance Band Presets 🎯</h3>
                    <div className="preset-workouts-grid">
                        {bandsWorkouts.map((workout, index) => (
                            <div
                                key={`${workout.code}-${index}`}
                                className="preset-workout-card"
                                onClick={() => handlePresetSelect(workout.code)}
                            >
                                <div className="preset-code">{workout.code}</div>
                                <div className="preset-name">{workout.name}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="bands-instructions">
                    <p>🔥 Variable resistance for progressive overload!</p>
                    <p>🎯 Portable and perfect for travel workouts</p>
                    <p>💯 Full-body training with minimal equipment!</p>
                </div>
            </div>
        </div>
    );
};

export default BandsSelection;